module.exports = __webpack_public_path__ + "static/img/pctGrid.200c059c.png";